module.exports = __webpack_public_path__ + "img/Private-Room-img.b2c5a2d0.png";